import jsonapi from 'jsonapi-parse';
import TechademiaCheckOrder from '@/models/read/TechademiaCheckOrder';

export default $axios => () => ({
    async list() {
        try {
            let response = await $axios.$get(`/rest/student/external-checks`);
            return jsonapi.parse(response).data.map(order => new TechademiaCheckOrder(order));
        } catch (error) {
            return [];
        }
    },
});
